import { baseApi } from "../baseApi";
import {
  HygieneSettings,
  HygieneSettingsResponse,
  HygieneSubmitRequest,
  HygieneSubmitResponse,
  HygieneTodayResponse,
} from "./type";

export const hygieneApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getHygieneToday: build.query<HygieneTodayResponse, void>({
      query: () => ({
        url: "/hygiene/checkins/today",
        method: "GET",
      }),
      providesTags: ["HygieneCheckins"],
    }),
    submitHygieneToday: build.mutation<HygieneSubmitResponse, HygieneSubmitRequest>({
      query: (body) => ({
        url: "/hygiene/checkins/today",
        method: "POST",
        body,
      }),
      invalidatesTags: ["HygieneCheckins", "HygieneStreak"],
    }),
    getHygieneSettings: build.query<HygieneSettingsResponse, void>({
      query: () => ({
        url: "/hygiene/checkins/settings",
        method: "GET",
      }),
      providesTags: ["HygieneSettings"],
    }),
    updateHygieneSettings: build.mutation<
      HygieneSettingsResponse,
      Partial<HygieneSettings>
    >({
      query: (body) => ({
        url: "/hygiene/checkins/settings",
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["HygieneSettings"],
    }),
  }),
});

export const {
  useGetHygieneTodayQuery,
  useSubmitHygieneTodayMutation,
  useGetHygieneSettingsQuery,
  useUpdateHygieneSettingsMutation,
} = hygieneApi;
